import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class ReportsService {
  constructor(private http: HttpClient) {
  }

  getprinting(userid) {
    return this.http.post<any>(AppConstants.SITE_URL +'report/get_print_user', { ids: userid });
  }



}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/services/report.service.ts